import { Link } from "react-router-dom";
import { CityPage, FAQ, CityProduct } from "./CityPage";
import { URLS } from "../../adds/product-links";

const products: CityProduct[] = [
  {
    title: "Fietspomp",
    description:
      "Utrechtse routes lopen vaak over langere stukken open polder. Een goede fietspomp voorkomt gedoe onderweg.",
    url: URLS.pump,
  },
  {
    title: "Fietsverlichting",
    description:
      "Veel Utrechtse routes gaan door parken of over rustige fietspaden waar verlichting hard nodig is.",
    url: URLS.lights,
  },
  {
    title: "Fietshelm",
    description:
      "Vooral handig voor studenten die dagelijks naar De Uithof of Utrecht Science Park fietsen.",
    url: URLS.helmet,
  },
];

const faqs: FAQ[] = [
  {
    question: "Waait het in Utrecht minder hard dan in kuststeden?",
    answer:
      "Ja, omdat Utrecht centraal in Nederland ligt is de gemiddelde windkracht iets lager dan in Amsterdam, Rotterdam of Haarlem. Maar bij zuidwestenwind kun je nog steeds stevige tegenwind krijgen, vooral op open polderroutes richting Woerden of het Groene Hart.",
  },
  {
    question: "Welke kant komt de wind meestal uit in Utrecht?",
    answer:
      "Net als in de rest van Nederland is de overheersende windrichting in Utrecht zuidwest. Routes richting het noorden of oosten hebben dus vaker wind mee.",
  },
  {
    question: "Is fietsen van Utrecht naar Amsterdam met de wind mee?",
    answer:
      "Vaak wel. De route loopt noordwestelijk en bij de doorgaande zuidwestenwind heb je meestal wind schuin in de rug. Op de terugweg van Amsterdam naar Utrecht is het doorgaans pittiger met tegenwind.",
  },
];

export function Utrecht() {
  return (
    <CityPage
      city="Utrecht"
      title="Fietsweer Utrecht | Heb ik tegenwind?"
      description="Check de windrichting en het fietsweer voor jouw route in en rond Utrecht. Meewind, tegenwind of zijwind, je weet het in één oogopslag."
      path="/fietsweer/utrecht"
      faqs={faqs}
      products={products}
    >
      <p>
        Utrecht is de fietsstad bij uitstek, met 's werelds grootste
        fietsenstalling onder het Jaarbeursplein en een binnenstad waar de
        fiets prioriteit heeft. Omdat Utrecht centraal in Nederland ligt is de
        wind hier doorgaans iets rustiger dan aan de kust, maar bij
        zuidwestenwind kun je nog steeds flinke tegenwind hebben op routes
        richting de Heuvelrug of over de open polder.
      </p>

      <h3>Wind in Utrecht: wat valt op?</h3>
      <p>
        De overheersende windrichting is ook hier zuidwest. Fiets je richting
        Maarssen, Woerden of de polders richting het westen, dan heb je
        meestal wind mee. Op de terugweg naar Utrecht Centraal is het vaak een
        kwestie van doorbijten. Richting de Utrechtse Heuvelrug (Zeist, Den
        Dolder, Amersfoort) bieden de bossen flink meer beschutting.
      </p>

      <h3>Populaire fietsroutes in Utrecht</h3>
      <ul>
        <li>
          <strong>Utrecht → Amsterdam:</strong> dé forenzenroute. Zie onze{" "}
          <Link to="/route/utrecht-amsterdam">
            speciale Utrecht-Amsterdam pagina
          </Link>{" "}
          voor meer info over wind op deze route.
        </li>
        <li>
          <strong>Utrecht → De Bilt / Zeist:</strong> via Rhijnauwen en door
          het bos; weinig tegenwind omdat je in de luwte fietst.
        </li>
        <li>
          <strong>Utrecht → Woerden:</strong> open polder, mooi weggetje maar
          bij westenwind een uitdaging.
        </li>
        <li>
          <strong>Utrecht → Houten / Nieuwegein:</strong> via de Kromme Rijn
          of over de brug bij Lunetten, afhankelijk van windrichting een
          pittige rit.
        </li>
      </ul>

      <h3>Check de wind voor jouw rit</h3>
      <p>
        Op de <Link to="/">fietsweer-tool</Link> voer je simpel je startpunt en
        bestemming in en krijg je per stuk van je route te zien of het
        tegenwind, meewind of zijwind is. Bruikbaar voor woon-werkverkeer,
        studenten die naar De Uithof fietsen, of weekendtochten door het
        Groene Hart.
      </p>

      <h3>Meer lezen</h3>
      <ul>
        <li>
          <Link to="/tegenwind-tips">Hoe fiets je effectief tegen de wind in</Link>
        </li>
        <li>
          <Link to="/waarom-draait-de-wind">Waarom draait de wind soms?</Link>
        </li>
      </ul>
    </CityPage>
  );
}
